'use strict';

class CardClient {
    constructor() {}

    index() {
        return new Promise(function(resolve, reject) {
            try {
                $.ajax({
                    method: 'GET',
                    url: '/wp-json/actions/robox-api/cards',
                })
                    .done((response) => {
                        return resolve(response);
                    })
                    .fail((response) => {
                        return reject(response);
                    });
            } catch (error) {
                // TODO BOX-298
            }
        });
    }
}

export default CardClient;



// WEBPACK FOOTER //
// ./scripts/clients/robox-api/CardClient.js